import { AfterViewInit, Component, HostListener, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDatepicker, MatPaginator, MatSort, PageEvent, Sort } from '@angular/material';
import { GoogleChartInterface } from 'ng2-google-charts/google-charts-interfaces';
import { ToastrService } from 'ngx-toastr';
import { SocketService } from '../../services';

@Component({
  selector: 'device-timeline',
  templateUrl: './device-timeline.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class DeviceTimelineComponent implements OnInit, AfterViewInit {
  @ViewChild('dayPicker') public dayPicker: MatDatepicker<Date>;
  @ViewChild('startDatePicker') public startDatePicker: MatDatepicker<Date>;
  @ViewChild('endDatePicker') public endDatePicker: MatDatepicker<Date>;
  @Input('licenseId') public licenseId: string;
  public filterDateOpt = 1;
  public monthDate;
  public timeoutSearch;

  public timelineChart: GoogleChartInterface;
  public daysFilterMap = [
    { value: 1, label: 'Last day' },
    { value: 7, label: 'Last week' },
    { value: 30, label: 'Last month' },
    { value: -1, label: 'Select day' },
    { value: -2, label: 'Select range' },
  ];
  public daysFilter: number;
  public deviceFilter: string;
  public now: Date;
  public isLoading: boolean;
  public resizeTimeout;

  @ViewChild(MatPaginator) public matPaginator: MatPaginator;
  @ViewChild(MatSort) public matSort: MatSort;
  public connections;
  public connectionsColumns = [
    'name',
    'props.clientId',
    'totalSessions',
    'sumSessionsMs',
    'avgSessionsMs',
    'maxSessionsMs',
  ];
  public totalRecords;

  constructor(
    private toastr: ToastrService,
    private socketService: SocketService,
  ) {
  }

  public ngOnInit() {
    this.now = new Date();
    this.isLoading = true;
    this.daysFilter = this.daysFilterMap[2].value;
    if (this.licenseId) this.getConnectivities();
    this.redraw();
  }
  public ngAfterViewInit(): void {
    if (this.matSort) {
      this.matSort.sortChange.subscribe((s: Sort) => {
        if (this.matPaginator) { this.matPaginator.pageIndex = 0; }
        this.getConnectivities();
      });
    }
  }

  // https://developers.google.com/chart/interactive/docs/gallery/timeline#configuration-options
  public initTimeline() {
    this.now = new Date();
    if (!this.timelineChart) {
      this.timelineChart = {
        chartType: 'Timeline',
        dataTable: [],
        options: {
          colors: ['green'],
          height: 100,
          /* timeline: {
            barLabelStyle: { fontSize: 11 },
            //rowLabelStyle: { fontSize: 20 },
          }, */
        },
      };
    }
  }
  @HostListener('window:resize')
  public onWindowResize() {
    this.redraw();
  }
  public redraw() {
    if (this.timelineChart && this.timelineChart.component) {
      this.timelineChart.component.draw();
    }
  }
  public timelineReady() {
    this.isLoading = false;
  }
  public getConnectivities() {
    this.isLoading = true;
    if (this.licenseId) {
      if (!this.timelineChart || !this.timelineChart.dataTable) { this.initTimeline(); }
      this.isLoading = true;
      const filters = this.getSessionFilters();
      this.socketService.getSessions(this.licenseId, filters).subscribe((data: any) => {
        if (data && data.length) {
          const sessions = data.map((s) => ([this.licenseId, new Date(s.startDate).getTime(), new Date(s.endDate).getTime()]));
          this.timelineChart.dataTable = [['Device', 'From', 'To'], ...sessions];
          setTimeout(() => { this.redraw(); }, 100);
        } else {
          this.timelineChart.dataTable = null;
        }
      });
      this.isLoading = false;
    } else {
      const filters = this.getFilters();
      this.socketService.getConnections(filters).subscribe((response: any) => {
        this.connections = response.data;
        this.totalRecords = response.totalRecords;
        this.isLoading = false;
      });
    }

    // this.socketService.getSessions(this.getFilters()).subscribe((data: C3Sessions) => {
    /* this.socketService.getConnectedSockets(this.getFilters()).subscribe((sockets: ConnectedSockets) => {
      if (!sockets.clients || !sockets.clients.length) {
        this.isLoading = false;
        this.timelineChart.dataTable = null;
        this.toastr.error('No connectivity history found');
      } else {
        const list = [];
        list.push(['Device', 'Status', 'From', 'To']);
        const sessions = sockets.clients.map((c) => (c.sessions.map((s) => (
          [c.props.clientId, 'online', new Date(s.startDate).getTime(), new Date(s.endDate).getTime()]
        ))));
        list.push(...[].concat.apply([], sessions));
        console.log('list', list);
        this.timelineChart.dataTable = list;
        this.isLoading = false;
        setTimeout(() => {
          this.redraw();
        }, 100);
      }
    }, () => {
      this.timelineChart.dataTable = null;
      this.isLoading = false;
    }); */
  }

  public getFilters() {
    const filters: any = {};
    if (this.licenseId) { filters.licenseId = this.licenseId; } else if (this.deviceFilter) { filters.licenseId = this.deviceFilter; }
    if (this.matSort && this.matSort.active && this.matSort.direction) {
      filters.sortBy = this.matSort.active;
      filters.sortByDir = this.matSort.direction;
    } else {
      filters.sortBy = 'maxSessionsMs';
      filters.sortByDir = 'desc';
    }
    switch (this.daysFilter) {
      case 1:
      case 7:
      case 15:
      case 30:
        const date = new Date(
          this.now.getTime() - this.daysFilter * 24 * 60 * 60 * 1000,
        );
        filters.startDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} 00:00`;
        break;
      case -1:
        // select day
        if (this.dayPicker && this.dayPicker._selected) {
          const startDate = new Date(this.dayPicker._selected);
          filters.startDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 00:00`;
          filters.endDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 23:59`;
        }
        break;
      case -2:
        // select range
        if (this.startDatePicker && this.startDatePicker._selected) {
          const startDate = new Date(this.startDatePicker._selected);
          filters.startDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 00:00`;
        }
        if (this.endDatePicker && this.endDatePicker._selected) {
          const endDate = new Date(this.endDatePicker._selected);
          filters.endDate = `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()} 23:59`;
        }
        break;
      default:
        console.log('daysFilter not recognized');
    }
    filters.page = (this.matPaginator && this.matPaginator.pageIndex) ? this.matPaginator.pageIndex : 0;
    filters.limit = (this.matPaginator && this.matPaginator.pageSize) ? this.matPaginator.pageSize : 5;
    return filters;
  }
  public getSessionFilters() {
    const filters: any = {};
    switch (this.daysFilter) {
      case 1:
      case 7:
      case 15:
      case 30:
        const date = new Date(
          this.now.getTime() - this.daysFilter * 24 * 60 * 60 * 1000,
        );
        filters.startDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} 00:00`;
        break;
      case -1:
        // select day
        if (this.dayPicker && this.dayPicker._selected) {
          const startDate = new Date(this.dayPicker._selected);
          filters.startDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 00:00`;
          filters.endDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 23:59`;
        }
        break;
      case -2:
        // select range
        if (this.startDatePicker && this.startDatePicker._selected) {
          const startDate = new Date(this.startDatePicker._selected);
          filters.startDate = `${startDate.getFullYear()}/${startDate.getMonth() + 1}/${startDate.getDate()} 00:00`;
        }
        if (this.endDatePicker && this.endDatePicker._selected) {
          const endDate = new Date(this.endDatePicker._selected);
          filters.endDate = `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()} 23:59`;
        }
        break;
      default:
        console.log('daysFilter not recognized');
    }
    return filters;
  }

  public onDaysFilterChange() {
    if (this.daysFilter > 0) { this.getConnectivities(); }
    if (this.daysFilter === -1) { this.dayPicker.open(); }
    if (this.daysFilter === -2) { this.startDatePicker.open(); }
  }

  public onDateChange() {
    if (this.daysFilter == -1) {
      // single day
      this.getConnectivities();
    } else {
      // range
      // startdate < enddate
      try {
        const start = this.startDatePicker._selected.getTime();
        const end = this.endDatePicker._selected.getTime();
        if (start && end && start <= end) {
          this.getConnectivities();
        } else {
          this.toastr.error('End date is before start date.');
        }
      } catch (error) {
        if (!this.startDatePicker._selected) { this.startDatePicker.open(); } else if (!this.endDatePicker._selected) { this.endDatePicker.open(); } else { this.toastr.error(error, 'Error reading dates.'); }
      }
    }
  }

  public onDeviceSearch(event) {
    if (!this.deviceFilter || (event && event.keyCode == 13)) {
      clearTimeout(this.timeoutSearch);
      this.getConnectivities();
      return;
    }

    if (this.timeoutSearch) {
      clearTimeout(this.timeoutSearch);
    }
    this.timeoutSearch = setTimeout(() => {
      this.getConnectivities();
    }, 800);
  }
  public pageChange(page?: PageEvent) {
    this.matPaginator.pageIndex = page.pageIndex;
    this.matPaginator.pageSize = page.pageSize;
    this.getConnectivities();
  }
}
